import { render, staticRenderFns } from "./productSelect.vue?vue&type=template&id=da2e25a4&scoped=true"
import script from "./productSelect.vue?vue&type=script&lang=js"
export * from "./productSelect.vue?vue&type=script&lang=js"
import style0 from "./productSelect.vue?vue&type=style&index=0&id=da2e25a4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da2e25a4",
  null
  
)

export default component.exports